import { FormFieldLocationTypeahead } from 'src/common/FormField/FormFieldLocationTypeahead';
import { SelectOption } from 'src/common/primitives/Select';

import { BillingAddress } from './types';
import { parsePlaceAddress } from './utils';

interface BillingAddressFormProps {
  className?: string;
  onChange: (address: BillingAddress, location: SelectOption) => void;
}

export function BillingAddressForm({
  className,
  onChange,
}: BillingAddressFormProps) {
  return (
    <div className={className} data-testid="billing-address-form">
      <FormFieldLocationTypeahead
        label="Address"
        inputProps={{
          id: 'billing-address-form-typeahead',
        }}
        onChange={async (e) => {
          const address = parsePlaceAddress(e.label);
          onChange(address, e);
        }}
      />
    </div>
  );
}
